import { Component, OnDestroy } from '@angular/core';
import { DeviceAssignmentHistory } from '@era/locations-sdk';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { map, Observable, Subscription } from 'rxjs';
import { AsyncPipe, DatePipe } from '@angular/common';
import {
  DeviceAssignmentHistoryStoreSelectors,
  DeviceAssignmentHistoryStoreStates,
} from '../device-assignment-history-store';

@Component({
  selector: 'era-assignment-history-modal',
  templateUrl: './assignment-history-modal.container.html',
  styleUrls: ['./assignment-history-modal.container.scss'],
  imports: [AsyncPipe, DatePipe],
})
export class AssignmentHistoryModalComponent implements OnDestroy {
  public readonly assignments$: Observable<DeviceAssignmentHistory[]>;
  private readonly subscriptions: Subscription[] = [];
  constructor(
    public readonly activeModal: NgbActiveModal,
    private readonly historyStore: Store<DeviceAssignmentHistoryStoreStates.DeviceAssignmentHistory>
  ) {
    this.assignments$ = this.historyStore
      .select(DeviceAssignmentHistoryStoreSelectors.selectDeviceAssignmentHistoryForCurrentUdid)
      .pipe(map((x) => x.sort((a, b) => new Date(b?.assignedAt)?.getTime() - new Date(a?.assignedAt)?.getTime())));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  getDisplayText(obj: DeviceAssignmentHistory): string {
    if (!obj) {
      return '';
    }

    if (!obj.location) {
      return 'Unassigned';
    }

    if (obj.kiosk) {
      return `${obj.location} | Kiosk`;
    }

    if (obj.frontDesk) {
      return `${obj.location} | Frontdesk`;
    }
    if (obj.housekeeping) {
      return `${obj.location} | Housekeeping`;
    }
    if (obj.bar) {
      return `${obj.location} | Bar`;
    }
    if (obj.staff) {
      return `${obj.location} | Staff`;
    }
    if (obj.room) {
      return `${obj.location} | Room ${obj.room}`;
    }

    return `${obj.location} | Spare`;
  }
}
